import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function onDelegateSet(_this__u8e3s4, delegate) {
  if (delegate == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var value = delegate;
    var tmp = value;
    tmp.zbh_1 = () => {
      // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
      var this_0 = _this__u8e3s4.tb5_1;
      var tmp0_safe_receiver = this_0.vb3_1;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        if (!(tmp0_safe_receiver instanceof HTMLCanvasElement))
          THROW_CCE();
        // Inline function 'kotlin.apply' call
        var this_1 = tmp0_safe_receiver.getContext('2d');
        if (!(this_1 instanceof CanvasRenderingContext2D))
          THROW_CCE();
        // Inline function 'org.w3c.dom.ROUND' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        this_1.lineCap = 'round';
        // Inline function 'org.w3c.dom.ROUND' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        this_1.lineJoin = 'round';
        value.ud9(this_1);
        tmp = Unit_instance;
      }
      if (tmp == null) {
        this_0.ub3_1.v((it) => {
          if (!(it instanceof HTMLCanvasElement))
            THROW_CCE();
          // Inline function 'kotlin.apply' call
          var this_0 = it.getContext('2d');
          if (!(this_0 instanceof CanvasRenderingContext2D))
            THROW_CCE();
          // Inline function 'org.w3c.dom.ROUND' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.unsafeCast' call
          this_0.lineCap = 'round';
          // Inline function 'org.w3c.dom.ROUND' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.unsafeCast' call
          this_0.lineJoin = 'round';
          value.ud9(this_0);
          return Unit_instance;
        });
      }
      return Unit_instance;
    };
    value.zbh_1();
  }
}
function setupResizeListener(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
  var this_0 = _this__u8e3s4.tb5_1;
  var tmp0_safe_receiver = this_0.vb3_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var htmlNative = tmp0_safe_receiver;
    if (!(htmlNative instanceof HTMLCanvasElement))
      THROW_CCE();
    (new ResizeObserver((_unused_var__etf5q3, _unused_var__etf5q3_0) => {
      // Inline function 'kotlin.apply' call
      var this_0 = htmlNative;
      var sw = roundToInt(this_0.scrollWidth * window.devicePixelRatio);
      var sh = roundToInt(this_0.scrollHeight * window.devicePixelRatio);
      if (!(this_0.width === sw) || !(this_0.height === sh)) {
        this_0.width = sw;
        this_0.height = sh;
      }
      var tmp0_safe_receiver = _this__u8e3s4.ybh_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.td9(sw, sh);
      }
      var tmp1_safe_receiver = _this__u8e3s4.ybh_1;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.zbh_1;
      if (tmp2_safe_receiver == null)
        null;
      else
        tmp2_safe_receiver();
      return Unit_instance;
    })).observe(htmlNative);
    tmp = Unit_instance;
  }
  if (tmp == null) {
    this_0.ub3_1.v((it) => {
      var htmlNative = it;
      if (!(htmlNative instanceof HTMLCanvasElement))
        THROW_CCE();
      (new ResizeObserver((_unused_var__etf5q3, _unused_var__etf5q3_0) => {
        // Inline function 'kotlin.apply' call
        var this_0 = htmlNative;
        var sw = roundToInt(this_0.scrollWidth * window.devicePixelRatio);
        var sh = roundToInt(this_0.scrollHeight * window.devicePixelRatio);
        if (!(this_0.width === sw) || !(this_0.height === sh)) {
          this_0.width = sw;
          this_0.height = sh;
        }
        var tmp0_safe_receiver = _this__u8e3s4.ybh_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.td9(sw, sh);
        }
        var tmp1_safe_receiver = _this__u8e3s4.ybh_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.zbh_1;
        if (tmp2_safe_receiver == null)
          null;
        else
          tmp2_safe_receiver();
        return Unit_instance;
      })).observe(htmlNative);
      return Unit_instance;
    });
  }
}
//region block: exports
export {
  onDelegateSet as onDelegateSet690ei966ebv5,
  setupResizeListener as setupResizeListener3vth0wdbpatzm,
};
//endregion

//# sourceMappingURL=Canvas.commonHtml.js.mjs.map
